import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba24a778"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account_info" }
const _hoisted_2 = { class: "account_info_content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "account_info_content_wrap" }
const _hoisted_5 = { class: "aicw_msg" }
const _hoisted_6 = { class: "aicw_member" }
const _hoisted_7 = { class: "aicw_member_text" }
const _hoisted_8 = { class: "userid" }
const _hoisted_9 = { class: "aicw_member_text" }
const _hoisted_10 = { class: "userlevel" }
const _hoisted_11 = {
  key: 0,
  class: "authentication"
}
const _hoisted_12 = { class: "account_info_wallet" }
const _hoisted_13 = { class: "account_info_wallet_date" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "到期时间", -1))
const _hoisted_15 = { class: "text_desc" }
const _hoisted_16 = { class: "account_info_wallet_income" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "收益余额", -1))
const _hoisted_18 = { class: "text_desc color_danger" }

import { computed, inject, ref } from 'vue';
import type { AccountInfoType } from '../types';
import { useStore } from 'vuex';
import { getRoleIcon, getNewVerRoleIcon } from '@/utils/common';
import CModal from '@/components/CModal.vue';
import router from '@/router';
import { useHomeStore } from '@/pinia/home';

const __default__ = {
  name: 'AccountInfo',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dataSource: null
  },
  setup(__props: any) {

const props = __props as { dataSource: AccountInfoType };

const store = useStore();
const userData = computed(() => store.state.user.userInfo);

const vipIcon = computed(() => {
  if (homeStore.isNewVersion) {
    return getNewVerRoleIcon(props.dataSource.role_id);
  } else {
    return getRoleIcon(props.dataSource.role_id);
  }
});
const homeStore = useHomeStore();
const walletVersionRole = computed(() => homeStore.funcData?.WalletVersion);
const isVisible = ref<boolean>(false);
// 去认证
const toCertify = () => {
  isVisible.value = true;
};
const toVerification = () => {
  router.push({ path: '/personal/set/certification' });
};
const isopenDelModal = () => {
  isVisible.value = !isVisible.value;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "account_info_content_avatar",
        src: _unref(userData).avatar
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, "你好，" + _toDisplayString(_unref(userData).name) + " ，欢迎登录管理后台！", 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(" 用户ID： "),
            _createElementVNode("span", _hoisted_8, _toDisplayString(props.dataSource.admin_id ? props.dataSource.admin_id : '********'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(" 版本： "),
            _createElementVNode("span", _hoisted_10, _toDisplayString(props.dataSource.version), 1),
            (props.dataSource.level_up && _unref(walletVersionRole))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'WalletVersion' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      class: "aicw_member_btn",
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("升级")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_unref(homeStore).funcData['Certification'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createTextVNode(" 实名认证： "),
            _createElementVNode("div", {
              class: _normalizeClass(
            props.dataSource.certification_status != 0 && props.dataSource.certification_status != 3
              ? 'primary_color'
              : 'tips_icon_color'
          )
            }, [
              _withDirectives(_createVNode(_component_svg_icon, {
                class: "svg_icon",
                "icon-class": "personalHighlight"
              }, null, 512), [
                [_vShow, props.dataSource.certification_status == 2 && props.dataSource.certification_type == 1]
              ]),
              _withDirectives(_createVNode(_component_svg_icon, {
                class: "svg_icon",
                "icon-class": "companyHigh"
              }, null, 512), [
                [_vShow, props.dataSource.certification_status == 2 && props.dataSource.certification_type == 2]
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(props.dataSource.certification_status == 0 || props.dataSource.certification_status == 3 ? 'cursor' : ''),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              props.dataSource.certification_view == 1
                ? props.dataSource.certification_status == 0
                  ? toCertify()
                  : toVerification()
                : ''
            ))
              }, _toDisplayString(props.dataSource.certification_status == 2
                ? props.dataSource.certification_type == 1
                  ? '个人认证'
                  : '企业认证'
                : props.dataSource.certification_status == 1
                ? '待审核'
                : props.dataSource.certification_status == 3
                ? '已驳回'
                : props.dataSource.certification_status == 0
                ? '去认证'
                : '--'), 3)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, _toDisplayString(props.dataSource.end_at) + " ", 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("p", _hoisted_18, "¥ " + _toDisplayString(props.dataSource.money), 1)
      ])
    ]),
    _createVNode(CModal, {
      visible: isVisible.value,
      close: isopenDelModal,
      centered: ""
    }, null, 8, ["visible"])
  ]))
}
}

})